import { Component, EventEmitter, OnInit } from '@angular/core';
import { IStatisticFilters, IStatisticParams } from '@shared-libs/interfaces';

@Component({
	selector: 'digicheque-statistics-component',
	templateUrl: 'digicheque-statistics.component.html',
	styleUrls: ['./digicheque-statistics.component.scss'],
})
export class DigichequeStatisticsComponent implements OnInit {
	public filters: IStatisticFilters;
	public params: IStatisticParams;
	public readonly paramsChanged: EventEmitter<IStatisticParams> = new EventEmitter();

	public ngOnInit(): void {
		this.params = {};
		this.filters = {};
	}
}
